<template>
    <el-card shadow="never" class="aui-card--fill">
      <el-calendar v-model="calendarValue">
        <template slot="dateCell" slot-scope="{date, data}">
          <div :class="data.isSelected ? 'is-selected' : ''">
            {{ data.day.split('-').slice(1).join('-') }}
            <div v-for="item in calendarList" :key="item.index">
                <div v-if="item.date == data.day.split('-').slice(1).join('-')">
                    <p style="font-size: 14px;">
                        {{item.hour}}
                    </p>
                    <p style="font-size: 14px;word-break: break-all;">
                        {{item.name}}
                    </p>
                    
                </div>
            </div>
          </div>
        </template>
      </el-calendar>
   
    </el-card>
  </template>
   
  <script>
  const utils = require("@/api/core/utils");
    export default {
      props: {
        formCreateInject: {
            type: Object,
            required: true,
        },
        dataSource: {
            type: String
        }
      },
      data() {
        return {
          calendarValue: new Date(),
          calendarList:[],
          fDataSource:this.dataSource
        };
      },
      computed: {
   
      },
      created() {
        this.calendarList = this.getValue();
      },
      mounted() {
      },
      watch: {
      },
      methods: {
        // 将组件的值返回
        getValue() {
            return this.calendarList;
        },
        // 修改组件的值
        setValue(val) {
            this.calendarList = val;
        },
        loadSourceData() {
            this.calendarList = utils.getSourceData(this.fDataSource);
        },
        updateSourceData() {
            utils.updateSourceData(this.fDataSource, this.calendarList);
        },
      },
      components: {},
    };
  </script>
   
  <style scoped lang="scss">
    .is-selected {
      color: #1989FA;
    }
   
    .item_config {
      background-color: #000;
      color: #fff;
      padding: 10px;
      box-sizing: border-box;
      margin-top: 20px;
      border-radius: 10px;
   
      ._key {
        float: left;
        width: 70px;
        text-align: right
      }
   
      ._value {
        width: 100%;
        padding-left: 80px;
        text-align: left;
   
      }
      .el-calendar-table .el-calendar-day {
        height: 110px !important;
      }
    }
  </style>